import api from '@/utils/api'
import apiV2 from '@/utils/apiV2'

export const state = () => ({})

export const getters = {}

export const actions = {
  async requestCategoriesQuicksearch(_, { pathParams }) {
    try {
      const { data } = await this.$fmAxiosV2.get(
        apiV2.categories.categoriesQuicksearch(),
        {
          params: pathParams
        }
      )
      return data
    } catch (err) {
      throw err
    }
  },
  async requestFiltersByFlDirCategoryId(_, params) {
    try {
      const { data } = await this.$axios.get(
        api.directory.getFiltersByCategoryId(),
        {
          params
        }
      )
      return data
    } catch (err) {
      throw err
    }
  },
  async requestCreateFlDirCompany(_, payload) {
    try {
      const { data } = await this.$axios.post(
        api.directory.createCompany(),
        payload
      )
      return data
    } catch (err) {
      throw err
    }
  },
  async requestUpdateIlDirCompany(_, payload) {
    try {
      const { data } = await this.$axios.post(
        api.directory.updateCompany(),
        payload
      )
      return data
    } catch (err) {
      throw err
    }
  },
  async requestSaveFlDirCompanyPreview(_, payload) {
    try {
      const { data } = await this.$axios.post(
        api.directory.saveCompanyPreview(),
        payload
      )
      return data
    } catch (err) {
      throw err
    }
  }
}

export const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
